// extracted by mini-css-extract-plugin
export default {"container":"not_3J9tr","inner":"not_inn_3OLqB","title":"not_tit_2qXxg","description":"not_des_25nFl","list":"not_lis_3XER3","items":"not_ite_1UqVl"};